import { createContext } from 'react';
import {
	TFileId,
	IItemForGetShortInfo,
	IFileData,
	TLanguageIDs,
	IMenuTranslation,
	ICreateVideo,
	TCategoryType,
} from 'types';

export type TVisibleForm = 'mainForm' | 'translations';
export type TSelectedItem = Nullable<string>;
export type TSourceUrlLocally = Nullable<string>;
export type TTCategoryType = null | TCategoryType;
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'createStudio'
	| 'success'
	| 'error'
	| 'fileSizeExceeded'
	| 'invalidFileFormat'
	| 'fileUploadError'
	| 'someTranslationIsEmpty';

export interface ICreateVideoState {
	visibleForm: TVisibleForm;
	fileId: TFileId;
	sourceUrlLocally: TSourceUrlLocally;
	fetchedStudios: IItemForGetShortInfo[];
	IDSelectedStudio: TSelectedItem;
	needRefetchStudios: boolean;
	nameOfVideo: string;
	fetchedCategories: IItemForGetShortInfo[];
	IDSelectedCategory: TSelectedItem;
	fileData: IFileData;
	fetchedLanguages: IItemForGetShortInfo[];
	IDsSelectedLanguages: TLanguageIDs[];
	selectedTranslationTab: TLanguageIDs | null;
	translations: IMenuTranslation[];
	dataForSubmit: ICreateVideo | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createVideoInitialState: ICreateVideoState = {
	visibleForm: 'mainForm',
	fileId: null,
	sourceUrlLocally: null,
	fetchedStudios: [],
	IDSelectedStudio: null,
	needRefetchStudios: false,
	nameOfVideo: '',
	fetchedCategories: [],
	IDSelectedCategory: null,
	fileData: {
		fileId: '',
		fileHash: null,
		fileName: null,
	},
	fetchedLanguages: [],
	IDsSelectedLanguages: [],
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateVideoContext extends ICreateVideoState {
	changeVisibleForm(value: TVisibleForm): void;
	setFileId(value: TFileId): void;
	setFetchedStudios(value: IItemForGetShortInfo[]): void;
	setIDStudio(value: TSelectedItem): void;
	refetchStudios(value: boolean): void;
	changeNameOfVideo(value: string): void;
	setFetchedCategories(value: IItemForGetShortInfo[]): void;
	setIDCategory(value: TSelectedItem): void;
	changeFileData(value: IFileData): void;
	setFetchedLanguages(value: IItemForGetShortInfo[]): void;
	setIDsLanguages(value: TLanguageIDs[]): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: ICreateVideo): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	resetFields(): void;
}

export const CreateVideoContext = createContext<ICreateVideoContext>({
	changeVisibleForm: () => undefined,
	setFileId: () => undefined,
	setFetchedStudios: () => undefined,
	setIDStudio: () => undefined,
	refetchStudios: () => undefined,
	changeNameOfVideo: () => undefined,
	setFetchedCategories: () => undefined,
	setIDCategory: () => undefined,
	changeFileData: () => undefined,
	setFetchedLanguages: () => undefined,
	setIDsLanguages: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createVideoInitialState,
});
